<span class="badge badge-cliente-analise-mercado-status-projetado-badge-pill badge-cliente-analise-mercado-status-projetado-badge-pill-em-negociacao"
    [title]="getTitle()">       
</span>